import React from 'react';

import PropTypes from 'prop-types';
import { Notification } from '@telus-uds/components-web';

import { StatusBarWrapper } from '../design/statusBar/css';
import { BoxWrapper } from '../form/css';
import { FooterMessage, FooterErrorContainer } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const FormButtons = ({
  isFormTouched,
  submit,
  saveAndExit,
  showFooterError,
  setShowFooterError,
  isSubmitting
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    formButtons: { submitButtonLabel, saveContinueLaterButtonLabel }
  } = localizedStrings;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            <button
              type="button"
              onClick={saveAndExit}
              className="frg-button color-purple"
              disabled={!isFormTouched}
            >
              {saveContinueLaterButtonLabel}
            </button>
            <button
              type="button"
              onClick={e => submit(e)}
              style={{ marginLeft: '1em' }}
              className="frg-button color-green"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : submitButtonLabel}
            </button>
            {showFooterError && (
              <FooterErrorContainer>
                <Notification
                  variant={{ validation: 'error' }}
                  copy="en"
                  dismissible
                  onDismiss={() => setShowFooterError(false)}
                >
                  Please fill out all required fields
                </Notification>
              </FooterErrorContainer>
            )}
          </>
        </BoxWrapper>
        <BoxWrapper>
          <FooterMessage>
            For any questions / errors in the form, please contact Faisal
            Khurshid in TELUS{' '}
            <a href="mailto:faisal.khurshid@telus.com">
              Faisal.Khurshid@telus.com
            </a>
          </FooterMessage>
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

FormButtons.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  saveAndExit: PropTypes.func.isRequired,
  showFooterError: PropTypes.bool.isRequired,
  setShowFooterError: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool
};

export default FormButtons;
